import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import Knowledge from "../pages/knowledge/page";
import About from "../pages/about/page";
import Booking from "../pages/booking/page";
import BookingSuccess from "../pages/booking-success/page";
import Contact from "../pages/contact/page";
import ProductDetail from "../pages/product-detail/page";
import ArticleDetail from "../pages/article-detail/page";
import HearingTest from "../pages/hearing-test/page";
import Association from "../pages/association/page";
import HearingChronicDisease from "../pages/hearing-chronic-disease/page";
import Faq from "../pages/faq/page";

import AsiaSummit from "../pages/asia-summit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/product/:id",
    element: <ProductDetail />,
  },
  {
    path: "/knowledge",
    element: <Knowledge />,
  },
  {
    path: "/hearing-chronic-disease",
    element: <HearingChronicDisease />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/article/:id",
    element: <ArticleDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/association",
    element: <Association />,
  },
  {
    path: "/asia-summit",
    element: <AsiaSummit />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "/booking-success",
    element: <BookingSuccess />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/hearing-test",
    element: <HearingTest />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;